module.exports = {"451030100":"八达镇","451030101":"古障镇","451030102":"那劳镇","451030103":"马蚌镇","451030203":"普合苗族乡","451030204":"西平乡","451030206":"那佐苗族乡","451030208":"足别瑶族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451030.json
// module id = 1975
// module chunks = 0